($ =>{
  var settings = {
    max_width: '480',
  }, default_tables = [], cards_list = [[]], index_list = [], data_target = 0;

  var ARROWS = $('<div>', { 'class': 'pagination-arrows' }).append([
    $('<a>', { 'class': 'btn arrow left disable', 'href':'#', 'title': 'Anterior'}).append([
      $('<i>', {'class': 'fa fa-angle-double-left'}),
      $('<span>', {'class': 'hidden'}).append('&lt;')
    ]),
    $('<a>', { 'class': 'btn arrow right disable', 'href':'#', 'title': 'Seguinte' }).append([
      $('<i>', { 'class': 'fa fa-angle-double-right' }),
      $('<span>', {'class': 'hidden'}).append('&gt;')
    ]),
  ]);


  /**
   * Check if the layout corresponds to mobile or tablet
   * @returns {boolean}
   */
  function isBreakPoint() {
    return $(window).width() <= settings.max_width;
  }

  /**
   * Change the DOM of the tables. Rows to cards.
   * @returns
   */
  function toCards(){
    var tables = $('.container table.carousel-table');
    tables.each(function () {
      var table = $(this);
      cards_list.push([]);
      if($(this).hasClass('table-no-results')){
        empyTable(table);
      }else{
        tableWithContent(table);
      }
    });
    $('.pagination-arrows .arrow').off('click', navigate);
    $('.pagination-arrows .arrow').each(function() {
        $(this).on('click', navigate);
    });
  }

  /**
   * Design for Table without results.
   * @returns
   */
  function empyTable(table) {
    var caption = table.find('caption').first();
    var cards = $('<div>', { 'class': 'cards cards-carousel', 'id':'carousel' + data_target, 'data-target': data_target });
    var card = $('<div>', { 'class': 'card', 'data-target': data_target });
    var card_head = $('<div>', { 'class': 'card-head' });
    var card_body = $('<div>', { 'class': 'card-body' });

    card.append(card_head.append($(caption).text()));

    var row = $('<div>', { 'class': 'row card-row' });
    var td = $(table).find('td');
    var content_label = $('<label>', { 'class': 'col-sm-12 card-col col-value-full' });

    $(content_label).text(td.text());
    row.append(content_label);
    card_body.append(row);
    card.append(card_body);
    cards_list[data_target].push(card);
    cards.append(cards_list[data_target][0]);
    table.parent().prepend(cards);
    table.remove();
    data_target++;
    index_list.push(0);
  }

  /**
   * Design for Table with content.
   * @returns
   */
  function tableWithContent(table) {
    var caption = table.find('caption').first();
    var cards = $('<div>', { 'class': 'cards cards-carousel', 'id':'carousel' + data_target, 'data-target': data_target });
    var th = table.find('thead th').not('.not-in-carousel');
    var tr = table.find('tbody tr').not('.not-in-carousel');

    tr.each(function () {
      var card = $('<div>', { 'class': 'card', 'data-target': data_target });
      var card_head = $('<div>', { 'class': 'card-head' });
      var card_body = $('<div>', { 'class': 'card-body' });
      card.append(card_head.append($(caption).text()));
      var state_color = '';
      if ($(this).hasClass('active')){
        state_color = 'active';
      }
      if ($(this).hasClass('danger')){
        state_color = 'danger';
      }
      if ($(this).hasClass('warning')){
        state_color = 'warning';
      }

      $(this).find('td').not('.not-in-carousel').each(function (index, value) {
        var row = $('<div>', { 'class': 'row card-row' });
        var title_label = $('<span>', { 'class': 'col-sm-6 card-col col-title' });
        var content_label = $('<span>', { 'class': 'col-sm-6 card-col col-value ' + state_color });
        title_label.text(th[index].textContent);
        if($(this).children().length === 0){
          $(content_label).text(this.textContent);
        } else {
          $(content_label).append($(this).children());
        }
        row.append(title_label);
        row.append(content_label);
        card_body.append(row);
      });

      if($(this).hasClass('clickable-row')){
        var link = $('<div>', { 'class': 'row card-row' }).append(
          $('<a>', {'href':$(this).data("href"), 'class': 'btn btn-lg btn-primary btn-card', 'text':'Ver Curso'})
        );
        card_body.append(link);
      }

      card.append(card_body);
      cards_list[data_target].push(card);
    });

    cards.append(cards_list[data_target][0]);
    table.parent().prepend(cards);

    if(cards_list[data_target].length > 1){
      var arrows = ARROWS.clone();
      $(arrows.children()[1]).removeClass('disable');
      table.parent().prepend(arrows);
    }

    table.remove();
    data_target++;
    index_list.push(0);
  }

  /**
   * Revert the change of the DOM to default
   * @returns
   */
  function toTable() {
    var cards = $('div[id^=carousel]');
    var arrows = $('.pagination-arrows');
    if (cards.length > 0){
      cards.each(function (index, value) {
        $(this).parent().prepend(default_tables[index]);
        $(this).remove();
      });
      default_tables = [];
      resetTablePlugins();
    }
    if(arrows.length > 0){
      arrows.each(function () {
        $(this).remove();
      });
      cards_list = [];
      index_list = [];
      data_target = 0;
    }
  }

  /**
   * Reactivate the table plugins
   * @returns
   */
  function resetTablePlugins() {
    // $('.table').DataTable( {
    //   paging: false,
    //   info: false,
    //   filter:false,
    //   responsive: false,
    //   autoWidth: false
    // } );
    $('.table-tooltip').tableTooltip();
    $(".clickable-row td").click(function() {
      var data_ref = $(this).parent().data("href");
      if(!$(this).hasClass('table-row-opts')){
        window.location = data_ref;
      }
    });
  }

  /**
   * Scroll between cards
   * @returns
   */
  function navigate(){
    var $this = $(this);
    var card = $this.parent().parent().find('.card');
    var target = card.parent().data("target");

    if($this.hasClass('right') && !$this.hasClass('disable')){
      if(index_list[target] < cards_list[target].length - 1){
        card.replaceWith(cards_list[target][++index_list[target]]);
        if($this.parent().children().hasClass('disable')){
          $this.parent().children().removeClass('disable');
        }
      }
    } else if($this.hasClass('left') && !$this.hasClass('disable')) {
      if(index_list[target] > 0){
        card.replaceWith(cards_list[target][--index_list[target]]);
        if($this.parent().children().hasClass('disable')){
          $this.parent().children().removeClass('disable');
        }
      }
    }

    if(index_list[target] == cards_list[target].length - 1 || index_list[target] == 0){
      $this.addClass('disable');
    }
  }

  $.fn.tableToCardsCarousel = function(options){

    settings = $.extend({}, settings, options );
    var tables = $('.container table.carousel-table');
    //save the initial table DOM for revert after convert tables to cards.
    tables.each(function () {
      default_tables.push($(this).clone());
    });

    if (isBreakPoint()) {
      toCards();
    }

    $(window).on('resize', function() {
      if (isBreakPoint()) {
        var tables = $('.container table.carousel-table');
        if(tables.length > 0){
          tables.each(function () {
            default_tables.push($(this).clone());
          });
        }
        toCards();
      } else {
        toTable();
      }
    });
  };
})(jQuery);


// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/table_to_card_carousel.js